import {
    Box,
    Table,
    Typography,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    CircularProgress
} from "@mui/material";
import { useLocation } from "react-router-dom";
import React from "react";
import * as Action from "../../actions/adminAction"
import ImageUpload from "../../Components/ImageUpload";
import { connect } from "react-redux";
import { BASE_URL } from "../../utils/urls";

const borderSx = "2px solid";
const videoCategories = ['Teacher or Principal video', 'Training video', 'Test 1 video', 'Test 2 video', 'Teacher/Principal Video (Monthly)', 'Students Video (Weekly)']

// ---- Signature upload constants ----
const MAX_SIGNATURE_SIZE_MB = 5;
const ALLOWED_SIGNATURE_TYPES = ["image/png", "image/jpeg", "image/jpg", "image/webp"];

// ---- Standard signature dimensions (in pixels) ----
const SIGNATURE_MIN_WIDTH = 150;
const SIGNATURE_MAX_WIDTH = 600;
const SIGNATURE_MIN_HEIGHT = 40;
const SIGNATURE_MAX_HEIGHT = 200;
const SIGNATURE_STANDARD_WIDTH = 300;
const SIGNATURE_STANDARD_HEIGHT = 100;

// ---- Editable field visual constants ----
const EDITABLE_BG = "#e3f2fd";          
const EDITABLE_BORDER_COLOR = "#42a5f5";
const EDITABLE_HOVER_BORDER = "#1e88e5";
const EDITABLE_FOCUS_BORDER = "#1565c0";
const EDITABLE_ICON_COLOR = "#1976d2";

const validateSignatureDimensions = (file) =>
    new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            const { width, height } = img;
            URL.revokeObjectURL(url);

            if (width < SIGNATURE_MIN_WIDTH || height < SIGNATURE_MIN_HEIGHT) {
                reject(
                    `Signature is too small (${width}×${height}px). Minimum allowed is ${SIGNATURE_MIN_WIDTH}×${SIGNATURE_MIN_HEIGHT}px.`
                );
                return;
            }
            if (width > SIGNATURE_MAX_WIDTH || height > SIGNATURE_MAX_HEIGHT) {
                reject(
                    `Signature is too large (${width}×${height}px). Maximum allowed is ${SIGNATURE_MAX_WIDTH}×${SIGNATURE_MAX_HEIGHT}px.`
                );
                return;
            }

            const ratio = width / height;
            if (ratio < 1.2 || ratio > 6) {
                reject(
                    `Signature aspect ratio looks unusual (${ratio.toFixed(2)}:1). Please use an image close to ${SIGNATURE_STANDARD_WIDTH}×${SIGNATURE_STANDARD_HEIGHT}px (3:1).`
                );
                return;
            }

            resolve({ width, height });
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject("Could not read the signature image. Please try another file.");
        };
        img.src = url;
    });

const uploadSignatureToServer = async (file, trainingId) => {
    const url = `${BASE_URL}/upload/photo`;
    const formData = new FormData();
    formData.append("image", file);
    formData.append("fileName", `trainer_signature_${trainingId || Date.now()}`);

    const res = await fetch(url, { method: "POST", body: formData });
    if (!res.ok) throw new Error("Signature upload failed");
    const data = await res.json();
    return data.url;
};

// ---- Helper: does a subject cell contain "real" data? ----
const hasRealModule = (text) => {
    const t = (text || "").trim();
    return t.length > 0 && t !== "-";
};

export const FormFill = ({
    getCategories,
    GenerRateReport
}) => {
    const [isGeneratingReport, setIsGeneratingReport] = React.useState(false);
    const [studentPresentCount, setStudentPresentCount] = React.useState({
        ekunPat: "",
        vidyarthi: "",
        vidyarthini: "",
        ekunUpasthit: "",
    });

    const [image, setImage] = React.useState(null);

    const [reportInfo, setReportInfo] = React.useState(null);
    const [reportInfoLoader, setReportInfoLoader] = React.useState(false);
    const [reportInfoError, setReportInfoError] = React.useState("");

    const [signatureFile, setSignatureFile] = React.useState(null);
    const [signaturePreview, setSignaturePreview] = React.useState("");
    const [signatureUrl, setSignatureUrl] = React.useState("");
    const [isUploadingSignature, setIsUploadingSignature] = React.useState(false);
    const [signatureError, setSignatureError] = React.useState("");
    const [signatureDims, setSignatureDims] = React.useState(null);

    const [isReportGenerated, setIsReportGenerated] = React.useState(false);

    const [categorywiseImage, setCategorywiseImage] = React.useState([]);
    const [selectedImages, setSelectedImages] = React.useState([]);

    const [headerValues, setHeaderValues] = React.useState({
        shaala: "शासकीय आश्रम शाळा",
        prakalpKaryalay: "",
    });

    const { state } = useLocation();

    const [sessionSubjectRows, setSessionSubjectRows] = React.useState(() => [
        {
            sessionType: "सैद्धांतिक",
            subject: state?.categoryType === "Theory" ? state?.trainingModuleName : "-",
            description: "",
        },
        {
            sessionType: "प्रात्यक्षिक",
            subject: state?.categoryType === "Practical" ? state?.trainingModuleName : "-",
            description: "",
        },
        { sessionType: "प्रक्षेत्र", subject: "", description: "" },
    ]);

    const buildSessionRowsFromReport = (result) => {
        const trainingDetails = Array.isArray(result?.trainingDetails)
            ? result.trainingDetails
            : [];

        if (trainingDetails.length > 0) {
            const categoryToSession = {
                Theory: "सैद्धांतिक",
                Practical: "प्रात्यक्षिक",
                Field: "प्रक्षेत्र",
            };

            const sessionOrder = ["सैद्धांतिक", "प्रात्यक्षिक", "प्रक्षेत्र"];

            const grouped = {
                "सैद्धांतिक": [],
                "प्रात्यक्षिक": [],
                "प्रक्षेत्र": [],
            };

            trainingDetails.forEach((td) => {
                const sessionType =
                    categoryToSession[td?.categoryType] || "सैद्धांतिक";
                grouped[sessionType].push({
                    moduleId: td?._id,
                    moduleName: td?.trainingModuleName || "",
                    description: "",
                });
            });

            return sessionOrder.map((sessionType) => {
                const modules = grouped[sessionType] || [];
                return {
                    sessionType,
                    subject: modules
                        .map((m) => m.moduleName)
                        .filter(Boolean)
                        .join("\n"),
                    description: modules
                        .map((m) => m.description || "")
                        .filter(Boolean)
                        .join("\n"),
                };
            });
        }

        const तपशील =
            result?.beneficiaryData?.["तपशील"] ||
            result?.totalBeneficiaryData?.["तपशील"] ||
            result?.assignTrainerObject?.beneficiaryData?.["तपशील"];

        if (!Array.isArray(तपशील) || तपशील.length === 0) return null;

        return तपशील.map((s) => {
            const modules = Array.isArray(s?.modules) ? s.modules : [];
            return {
                sessionType: s?.sessionType || "",
                subject: modules
                    .map((m) => m?.moduleName || "")
                    .filter(Boolean)
                    .join("\n"),
                description: modules
                    .map((m) => m?.description || "")
                    .filter(Boolean)
                    .join("\n"),
            };
        });
    };

    const getReportInfo = async () => {
        if (!state?.trainingModule_id && !state?.grampanchayat_id) return;

        setReportInfoLoader(true);
        setReportInfoError("");

        try {
            const payload = {
                trainingModule_id: state?.trainingModule_id || "",
                grampanchayat_id: state?.grampanchayat_id || "",
                trainerName: state?.trainerName || "",
                startDate: state?.fromDate ? state.fromDate.split("T")[0] : "",
            };

            const response = await fetch(
                BASE_URL + "/report/getreport/getReportDataByTrainerNew",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();

            setReportInfo(result);

            if (result && typeof result === "object" && !Array.isArray(result)) {
                const hasReportUrl =
                    Array.isArray(result?.reportURL) && result.reportURL.length > 0;
                const hasImageData =
                    Array.isArray(result?.imageData) && result.imageData.length > 0;
                const isCompleted = result?.reportStatus === "COMPLETED";

                setIsReportGenerated(hasReportUrl || hasImageData || isCompleted);

                const bd =
                    result?.beneficiaryData ||
                    result?.totalBeneficiaryData ||
                    result?.assignTrainerObject?.beneficiaryData;

                if (bd && typeof bd === "object") {
                    setStudentPresentCount((prev) => ({
                        ...prev,
                        ekunPat: bd["एकूण पट"] ?? prev.ekunPat,
                        vidyarthi: bd["उपस्थित विद्यार्थी"] ?? prev.vidyarthi,
                        vidyarthini: bd["उपस्थित विद्यार्थिनी"] ?? prev.vidyarthini,
                        ekunUpasthit:
                            bd["एकूण उपस्थित"] !== undefined
                                ? String(bd["एकूण उपस्थित"])
                                : prev.ekunUpasthit,
                    }));

                    setHeaderValues((prev) => ({
                        shaala: bd["शाळा"] || prev.shaala || "शासकीय आश्रम शाळा",
                        prakalpKaryalay:
                            bd["प्रकल्प कार्यालय"] ?? prev.prakalpKaryalay ?? "",
                    }));
                }

                const rows = buildSessionRowsFromReport(result);
                if (rows && rows.length > 0) {
                    setSessionSubjectRows(rows);
                }

                if (result?.trainerSignature) {
                    setSignatureUrl(result.trainerSignature);
                } else if (result?.assignTrainerObject?.trainerSignature) {
                    setSignatureUrl(result.assignTrainerObject.trainerSignature);
                } else if (state?.trainerSignature) {
                    setSignatureUrl(state.trainerSignature);
                }

                const imageSource =
                    (Array.isArray(result?.imageData) && result.imageData.length > 0
                        ? result.imageData
                        : null) ||
                    (Array.isArray(result?.assignTrainerObject?.imageData) &&
                        result.assignTrainerObject.imageData.length > 0
                        ? result.assignTrainerObject.imageData
                        : null);

                if (imageSource) {
                    setCategorywiseImage(
                        imageSource.map((obj) => ({
                            categoryName: obj?.categoryName || "",
                            images: Array.isArray(obj?.images) ? obj.images : [],
                            showUpload: false,
                        }))
                    );
                }
            }
        } catch (error) {
            console.error("Failed to fetch report info:", error);
            setReportInfoError("Failed to load report info");
            setReportInfo(null);
        } finally {
            setReportInfoLoader(false);
        }
    };

    const getAllCategories = async () => {
        try {
            const result = await getCategories({
                "grampanchayat_id": state?.grampanchayat_id,
                "trainingModule_id": state?.trainingModule_id,
                "training_id": state?._id,
                "isReport": true,
            })

            if (result) {
                const data = []
                result.forEach(obj => {
                    const catData = {
                        categoryName: obj?._id,
                        images: obj?.category?.map(oo => oo.documentUrl) ?? [],
                        showUpload: false
                    }
                    data.push(catData)
                })

                setCategorywiseImage(prev =>
                    prev && prev.length > 0 ? prev : data
                )
            }
        } catch (error) {
            console.error("Failed to load categories:", error);
        } finally {
        }
    }

    const handleSignatureChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setSignatureError("");
        setSignatureDims(null);

        if (!ALLOWED_SIGNATURE_TYPES.includes(file.type)) {
            const msg = "Only PNG, JPG, JPEG or WEBP images are allowed.";
            setSignatureError(msg);
            alert(msg);
            e.target.value = "";
            return;
        }

        const maxBytes = MAX_SIGNATURE_SIZE_MB * 1024 * 1024;
        if (file.size > maxBytes) {
            const msg = `Signature file must be under ${MAX_SIGNATURE_SIZE_MB} MB. Your file is ${(file.size / 1024 / 1024).toFixed(2)} MB.`;
            setSignatureError(msg);
            alert(msg);
            e.target.value = "";
            return;
        }

        if (file.size === 0) {
            const msg = "Selected file is empty. Please choose a valid image.";
            setSignatureError(msg);
            alert(msg);
            e.target.value = "";
            return;
        }

        try {
            const dims = await validateSignatureDimensions(file);
            setSignatureDims(dims);
        } catch (dimError) {
            setSignatureError(dimError);
            alert(dimError);
            e.target.value = "";
            return;
        }

        setSignatureFile(file);
        setSignaturePreview(URL.createObjectURL(file));

        setIsUploadingSignature(true);
        try {
            const uploaded = await uploadSignatureToServer(file, state?._id);
            if (typeof uploaded === "string" && uploaded.startsWith("http")) {
                setSignatureUrl(uploaded);
            } else {
                setSignatureError("Upload did not return a valid URL");
                console.warn("Signature upload response:", uploaded);
            }
        } catch (err) {
            console.error("Signature upload failed:", err);
            setSignatureError("Signature upload failed. Please try again.");
        } finally {
            setIsUploadingSignature(false);
        }
    };

    React.useEffect(() => {
        return () => {
            if (signaturePreview) URL.revokeObjectURL(signaturePreview);
        };
    }, [signaturePreview]);

    const handleCopyModuleName = (sourceSessionType) => {
        setSessionSubjectRows((rows) => {
            const source = rows.find((r) => r.sessionType === sourceSessionType);
            const sourceText = (source?.subject || "").trim();
            if (!sourceText) return rows;

            const targetSessionType =
                sourceSessionType === "सैद्धांतिक" ? "प्रात्यक्षिक" : "सैद्धांतिक";

            return rows.map((r) =>
                r.sessionType === targetSessionType
                    ? { ...r, subject: sourceText }
                    : r
            );
        });
    };

    const handleGenerateReport = async () => {
        if (isGeneratingReport) return;
        if (!signatureUrl) {
            setSignatureError("Please upload the trainer's signature before generating the report.");
            document.getElementById("signature-section")?.scrollIntoView({ behavior: "smooth" });
            return;
        }

        setIsGeneratingReport(true);

        try {
            const baseBd =
                reportInfo?.beneficiaryData ||
                reportInfo?.totalBeneficiaryData ||
                {};

            // Helper to extract subject from current UI state
            const getSubjectFromRows = (type) => {
                const row = sessionSubjectRows.find(r => r.sessionType === type);
                return row?.subject || "";
            };

            // ---- FIX: Read directly from sessionSubjectRows first, then fallback ----
            const beneficiaryData = {
                ...baseBd,
                "एकूण पट": studentPresentCount.ekunPat,
                "उपस्थित विद्यार्थी": studentPresentCount.vidyarthi,
                "उपस्थित विद्यार्थिनी": studentPresentCount.vidyarthini,
                "एकूण उपस्थित": studentPresentCount.ekunUpasthit,

                "शाळा": headerValues.shaala || "शासकीय आश्रम शाळा",
                "गाव": baseBd["गाव"] || state?.grampanchayatName || "-",
                "तालुका": baseBd["तालुका"] || state?.talukaName || "-",
                "जिल्हा": baseBd["जिल्हा"] || state?.districtName || "-",
                "प्रकल्प कार्यालय": headerValues.prakalpKaryalay || baseBd["प्रकल्प कार्यालय"] || "",
                "तारीख": baseBd["तारीख"] || state?.tarikh,
                "प्रशिक्षक": baseBd["प्रशिक्षक"] || state?.trainerName || "-",
                
                // 🔥 THIS WAS THE BUG. Now it reads from UI state first.
                "सैद्धांतिक": getSubjectFromRows("सैद्धांतिक") || baseBd["सैद्धांतिक"] || "-",
                "प्रात्यक्षिक": getSubjectFromRows("प्रात्यक्षिक") || baseBd["प्रात्यक्षिक"] || "-",
                "प्रक्षेत्र": getSubjectFromRows("प्रक्षेत्र") || baseBd["प्रक्षेत्र"] || "-",

                "तपशील": sessionSubjectRows.map(
                    ({ sessionType, subject, description }) => ({
                        sessionType,
                        modules: subject
                            ? subject.split("\n").filter(Boolean).map((moduleName, i) => ({
                                moduleName,
                                description: description
                                    ? description.split("\n")[i] || ""
                                    : "",
                            }))
                            : [],
                    })
                ),
                categoryType: baseBd?.categoryType || state?.categoryType,
            };

            const imageData = categorywiseImage.reduce(
                (selectedCategories, { categoryName, images }) => {
                    const selectedCategoryImages = images.filter((imageItem) =>
                        selectedImages.some(
                            (selectedImage) =>
                                selectedImage.categoryName === categoryName &&
                                selectedImage.image === imageItem
                        )
                    );

                    if (selectedCategoryImages.length) {
                        selectedCategories.push({
                            categoryName,
                            images: selectedCategoryImages,
                        });
                    }

                    return selectedCategories;
                },
                []
            );

            const finalImageData =
                imageData.length > 0
                    ? imageData
                    : categorywiseImage.map((c) => ({
                        categoryName: c.categoryName,
                        images: c.images,
                    }));

            const data = {
                trainer_idAll: reportInfo?.assignTrainerObject?.trainer_idAll || state?.trainer_idAll,
                trainerNameAll: reportInfo?.assignTrainerObject?.trainerNameAll || state?.trainerNameAll,
                trainerMobileAll: reportInfo?.assignTrainerObject?.trainerMobileAll || state?.trainerMobileAll,
                trainerSignature: signatureUrl || state?.trainerSignature,
                trainerCount: reportInfo?.assignTrainerObject?.trainerCount || state?.trainerCount,
                docUploadedCount: reportInfo?.assignTrainerObject?.docUploadedCount || state?.docUploadedCount,
                docApprovedCount: reportInfo?.assignTrainerObject?.docApprovedCount || state?.docApprovedCount,
                typeOfDoc: state?.typeOfDoc,
                typeOfDocStatus: state?.typeOfDocStatus,
                isAssigned: state?.isAssigned,
                isApprovedFinal: state?.isApprovedFinal,
                isRejectedFinal: state?.isRejectedFinal,
                totalBeneficiaryData: reportInfo?.totalBeneficiaryData || reportInfo?.beneficiaryData || state?.totalBeneficiaryData,
                castBifircation: state?.castBifircation,
                representative: state?.representative,
                feedbackformData: state?.feedbackformData,
                resultform: state?.resultform,
                status: state?.status,
                isDelete: state?.isDelete,
                _id: reportInfo?._id || state?._id,
                trainer_id: reportInfo?.assignTrainerObject?.trainer_id || state?.trainer_id,
                trainerName: reportInfo?.trainerName || state?.trainerName,
                trainingModule_id: reportInfo?.trainingModuleId || state?.trainingModule_id,
                trainingModuleName: reportInfo?.trainingModuleName || state?.trainingModuleName,
                distric_id: state?.distric_id,
                districtName: reportInfo?.districtName || state?.districtName,
                taluka_id: reportInfo?.talukaId || state?.taluka_id,
                talukaName: reportInfo?.talukaName || state?.talukaName,
                grampanchayat_id: reportInfo?.grampanchayatId || state?.grampanchayat_id,
                grampanchayatName: reportInfo?.grampanchayatName || state?.grampanchayatName,
                createdBy: state?.createdBy,
                createdAt: state?.createdAt,
                updatedAt: state?.updatedAt,
                endDate: reportInfo?.endDate || state?.endDate,
                shift: state?.shift,
                startDate: reportInfo?.startDate || state?.startDate,
                updatedBy: state?.updatedBy,
                beneficiaryData,
                imageData: finalImageData,
            };


            const res = await GenerRateReport(data);
            const pdfUrl = typeof res === "string" ? res : res?.pdfUrl;

            if (!pdfUrl) {
                throw new Error(
                    res?.message || "Report generation did not return a PDF URL."
                );
            }

            const link = document.createElement("a");
            link.href = pdfUrl;
            link.target = "_blank";
            link.rel = "noopener noreferrer";
            document.body.appendChild(link);
            link.click();
            link.remove();
            getReportInfo();
        } catch (error) {
            console.error("Failed to generate or download report:", error);
        } finally {
            setIsGeneratingReport(false);
        }
    };

    React.useEffect(() => {
        getAllCategories()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        getReportInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state?.trainingModule_id, state?.grampanchayat_id, state?.trainerName]);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: { xs: 2, sm: 2.5 },
                minHeight: "100vh",
                width: "100%",
                minWidth: 0,
                overflowX: "hidden",
                paddingBottom: { xs: 3, sm: 4 },
                boxSizing: "border-box",
            }}
        >
            <Typography
                sx={{
                    width: "100%",
                    margin: { xs: "12px 0 4px", sm: "20px 0 8px" },
                    fontSize: { xs: 24, sm: 32, md: 40 },
                    fontWeight: 700,
                    textAlign: "center",
                }}
            >
                प्रशिक्षण अहवाल
            </Typography>

            {reportInfoLoader && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress size={20} />
                    <Typography>Loading report info...</Typography>
                </Box>
            )}
            {reportInfoError && (
                <Typography sx={{ color: "red" }}>{reportInfoError}</Typography>
            )}

            <TrainingFormHeader
                values={{
                    shaala: headerValues.shaala,
                    gaon: reportInfo?.beneficiaryData?.["गाव"] || reportInfo?.totalBeneficiaryData?.["गाव"] || state?.grampanchayatName || "-",
                    taluka: reportInfo?.beneficiaryData?.["तालुका"] || reportInfo?.totalBeneficiaryData?.["तालुका"] || state?.talukaName || "-",
                    jilha: reportInfo?.beneficiaryData?.["जिल्हा"] || reportInfo?.totalBeneficiaryData?.["जिल्हा"] || state?.districtName || "-",
                    prakalpKaryalay: headerValues.prakalpKaryalay,
                    tarikh: state?.fromDate ? state.fromDate.split("T")[0] : "-",
                    prashikshak: reportInfo?.beneficiaryData?.["प्रशिक्षक"] || reportInfo?.totalBeneficiaryData?.["प्रशिक्षक"] || state?.trainerName || "-",
                }}
                editableFields={["shaala", "prakalpKaryalay"]}
                editable={true}
                onChange={(field, val) => {
                    if (field === "shaala" || field === "prakalpKaryalay") {
                        setHeaderValues((prev) => ({ ...prev, [field]: val }));
                    }
                }}
            />

            <SessionSubjectDetails
                rows={sessionSubjectRows}
                onDescriptionChange={(rowIndex, description) =>
                    setSessionSubjectRows((rows) =>
                        rows.map((row, index) =>
                            index === rowIndex ? { ...row, description } : row
                        )
                    )
                }
                onSubjectChange={(rowIndex, subject) =>
                    setSessionSubjectRows((rows) =>
                        rows.map((row, index) =>
                            index === rowIndex ? { ...row, subject } : row
                        )
                    )
                }
                onCopyModuleName={handleCopyModuleName}
            />

            <StudentAttendanceCount
                values={studentPresentCount}
                onChange={(field, val) =>
                    setStudentPresentCount((prev) => ({ ...prev, [field]: val }))
                }
            />

            <Box
                sx={{
                    width: "100%",
                    maxWidth: 1024,
                    display: "flex",
                    boxSizing: "border-box",
                    flexDirection: "column",
                    border: "2px solid",
                    borderRadius: 2,
                    padding: { xs: 1, sm: 2.5 },
                    gap: { xs: 1.5, sm: 2.5 },
                    minWidth: 0,
                }}
            >
                {categorywiseImage
                    .filter((item) => !videoCategories.includes(item.categoryName))
                    .map(({ images, showUpload, categoryName }, index) => (
                        <Box
                            key={categoryName}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                border: "2px solid",
                                borderRadius: 2,
                                gap: { xs: 1.5, sm: 2.5 },
                                padding: { xs: 1, sm: 2.5 },
                                minWidth: 0,
                            }}
                        >
                            <Typography
                                sx={{
                                    margin: { xs: "4px 0", sm: "8px 12px" },
                                    fontSize: { xs: 18, sm: 20 },
                                    fontWeight: 600,
                                    overflowWrap: "anywhere",
                                }}
                            >
                                {categoryName}
                            </Typography>

                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    alignItems: "flex-start",
                                    gap: { xs: 1, sm: 2.5 },
                                    minWidth: 0,
                                }}
                            >
                                {images.map((img, index2) => {
                                    const isSelected = selectedImages.some(
                                        (selectedImage) =>
                                            selectedImage.categoryName === categoryName &&
                                            selectedImage.image === img
                                    );

                                    return (
                                        <Box
                                            key={`${categoryName}-${img?.name || index2}`}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                width: { xs: "100%", sm: "auto" },
                                                maxWidth: "100%",
                                                "& img": {
                                                    maxWidth: "100%",
                                                    height: "auto",
                                                },
                                            }}
                                        >
                                            <ImageUpload
                                                value={img}
                                                maxSizeMB={5}
                                                onChange={(newImage) => {
                                                    if (newImage === null) {
                                                        const updatedList = images.filter(
                                                            (_, imageIndex) => imageIndex !== index2
                                                        );

                                                        setSelectedImages((prev) =>
                                                            prev.filter(
                                                                (selectedImage) =>
                                                                    selectedImage.categoryName !==
                                                                    categoryName ||
                                                                    selectedImage.image !== img
                                                            )
                                                        );
                                                        setCategorywiseImage((prev) =>
                                                            prev.map((item) =>
                                                                item.categoryName === categoryName
                                                                    ? {
                                                                        ...item,
                                                                        images: updatedList,
                                                                        showUpload: !updatedList.length,
                                                                    }
                                                                    : item
                                                            )
                                                        );
                                                    }
                                                }}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={isSelected}
                                                        onChange={() =>
                                                            setSelectedImages((prev) =>
                                                                isSelected
                                                                    ? prev.filter(
                                                                        (selectedImage) =>
                                                                            selectedImage.categoryName !==
                                                                            categoryName ||
                                                                            selectedImage.image !== img
                                                                    )
                                                                    : [...prev, { categoryName, image: img }]
                                                            )
                                                        }
                                                    />
                                                }
                                                label="Choose"
                                            />
                                        </Box>
                                    );
                                })}

                                {showUpload && images.length < 3 && (
                                    <ImageUpload
                                        value={image}
                                        onChange={(newImage) => {
                                            if (newImage) {
                                                setCategorywiseImage((prev) =>
                                                    prev.map((item) => {
                                                        if (item.categoryName === categoryName) {
                                                            return {
                                                                ...item,
                                                                images: [...item.images, newImage],
                                                                showUpload: false,
                                                            };
                                                        }
                                                        return item;
                                                    })
                                                );
                                            }
                                        }}
                                        maxSizeMB={5}
                                    />
                                )}
                            </Box>
                        </Box>
                    ))}
            </Box>

            <Box
                id="signature-section"
                sx={{
                    width: "100%",
                    maxWidth: 1024,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    mt: 1,
                }}
            >
                <Typography sx={{ fontWeight: 700, textAlign: "left" }}>
                    प्रशिक्षकांची स्वाक्षरी - {state?.trainerName || "-"}
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flexWrap: "wrap",
                    }}
                >
                    <Button
                        variant="outlined"
                        component="label"
                        size="small"
                        disabled={isUploadingSignature}
                        sx={{ textTransform: "none" }}
                    >
                        {isUploadingSignature
                            ? "Uploading..."
                            : signatureFile
                                ? "Change Signature"
                                : "Upload Signature"}
                        <input
                            type="file"
                            accept="image/png,image/jpeg,image/jpg,image/webp"
                            hidden
                            onChange={handleSignatureChange}
                        />
                    </Button>

                    {isUploadingSignature && <CircularProgress size={20} />}

                    {signaturePreview && (
                        <Box
                            sx={{
                                border: "2px solid #1976d2",
                                borderRadius: 1,
                                padding: 0.5,
                                maxWidth: 220,
                                background: "#fff",
                            }}
                        >
                            <img
                                src={signaturePreview}
                                alt="signature preview"
                                style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    maxHeight: 90,
                                    objectFit: "contain",
                                }}
                            />
                        </Box>
                    )}

                    {!signaturePreview && signatureUrl && (
                        <Box
                            sx={{
                                border: "2px solid #1976d2",
                                borderRadius: 1,
                                padding: 0.5,
                                maxWidth: 220,
                                background: "#fff",
                            }}
                        >
                            <img
                                src={signatureUrl}
                                alt="trainer signature"
                                style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    maxHeight: 90,
                                    objectFit: "contain",
                                }}
                            />
                        </Box>
                    )}
                </Box>

                <Typography variant="caption" sx={{ color: "#666" }}>
                    Allowed: PNG / JPG / JPEG / WEBP · Max {MAX_SIGNATURE_SIZE_MB} MB
                    <br />
                    Standard dimensions: {SIGNATURE_STANDARD_WIDTH}×{SIGNATURE_STANDARD_HEIGHT}px (3:1 ratio).
                    Allowed range: {SIGNATURE_MIN_WIDTH}×{SIGNATURE_MIN_HEIGHT}px to {SIGNATURE_MAX_WIDTH}×{SIGNATURE_MAX_HEIGHT}px.
                </Typography>

                {signatureDims && !signatureError && (
                    <Typography variant="caption" sx={{ color: "#1976d2" }}>
                        Selected image: {signatureDims.width}×{signatureDims.height}px
                    </Typography>
                )}

                {signatureUrl && !signatureError && (
                    <Typography variant="caption" sx={{ color: "green" }}>
                        ✓ Signature uploaded
                    </Typography>
                )}
                {signatureError && (
                    <Typography variant="caption" sx={{ color: "red" }}>
                        {signatureError}
                    </Typography>
                )}
            </Box>

            <Button
                variant="contained"
                onClick={handleGenerateReport}
                disabled={isGeneratingReport || isUploadingSignature}
                startIcon={
                    isGeneratingReport ? (
                        <CircularProgress size={18} color="inherit" />
                    ) : null
                }
                sx={{
                    backgroundColor: "#1d5a96",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: 600,
                    padding: "10px 24px",
                    borderRadius: "6px",

                    "&:hover": {
                        backgroundColor: "#154675",
                    },
                }}
            >
                {isGeneratingReport
                    ? "Generating..."
                    : isReportGenerated
                        ? "Regenerate Report"
                        : "Generate Report"}
            </Button>
        </Box>
    );
};


/**
 * TrainingFormHeader
 */
const TrainingFormHeader = ({
    values = {},
    editable = false,
    editableFields = null,
    onChange = null,
}) => {
    const isFieldEditable = (fieldName) => {
        if (editableFields && editableFields.length > 0) {
            return editableFields.includes(fieldName);
        }
        return editable;
    };

    return (
        <Box
            sx={{
                border: borderSx,
                borderRight: "0px",
                borderColor: "text.primary",
                width: "100%",
                maxWidth: 1024,
                minWidth: 0,
                fontFamily:
                    '"Noto Sans Devanagari", "Mangal", Arial, sans-serif',
            }}
        >
            <FormRow>
                <FormCell
                    label="शाळा"
                    name="shaala"
                    value={values.shaala}
                    editable={isFieldEditable("shaala")}
                    onChange={onChange}
                />
            </FormRow>

            <FormRow>
                <FormCell
                    label="गाव"
                    name="gaon"
                    value={values.gaon}
                    editable={isFieldEditable("gaon")}
                    onChange={onChange}
                />
                <FormCell
                    label="तालुका"
                    name="taluka"
                    value={values.taluka}
                    editable={isFieldEditable("taluka")}
                    onChange={onChange}
                />
            </FormRow>

            <FormRow>
                <FormCell
                    label="जिल्हा"
                    name="jilha"
                    value={values.jilha}
                    editable={isFieldEditable("jilha")}
                    onChange={onChange}
                    labelWidth={110}
                />
                <FormCell
                    label="प्रकल्प कार्यालय"
                    name="prakalpKaryalay"
                    value={values.prakalpKaryalay}
                    editable={isFieldEditable("prakalpKaryalay")}
                    onChange={onChange}
                    labelWidth={150}
                />
            </FormRow>

            <FormRow isLast>
                <FormCell
                    label="तारीख"
                    name="tarikh"
                    value={values.tarikh}
                    editable={isFieldEditable("tarikh")}
                    onChange={onChange}
                />
                <FormCell
                    label="प्रशिक्षक"
                    name="prashikshak"
                    value={values.prashikshak}
                    editable={isFieldEditable("prashikshak")}
                    onChange={onChange}
                    labelWidth={150}
                />
            </FormRow>
        </Box>
    );
};


const FormCell = ({
    label,
    name,
    value = "",
    onChange = null,
    editable = false,
    labelWidth = 110,
}) => {
    const handleChange = (e) => {
        if (onChange) onChange(name, e.target.value);
    };

    return (
        <Box className="form-cell" sx={{ display: "flex", flex: 1, minWidth: 0 }}>
            <Box
                sx={{
                    width: { xs: Math.min(labelWidth, 120), md: labelWidth },
                    maxWidth: { xs: "45%", md: "none" },
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    px: { xs: 1, sm: 1.5 },
                    py: 1,
                    fontWeight: 700,
                    fontSize: { xs: "0.8rem", sm: "0.95rem" },
                    borderRight: borderSx,
                    borderColor: "text.primary",
                    overflowWrap: "anywhere",
                }}
            >
                {label}
            </Box>

            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    px: { xs: 1, sm: 1.5 },
                    py: 0.5,
                    minWidth: 0,
                    borderRight: borderSx,
                    borderColor: "text.primary",
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        width: "100%",
                        borderRadius: "4px",
                        backgroundColor: editable ? EDITABLE_BG : "transparent",
                        ...(editable && {
                            border: `1.5px dashed ${EDITABLE_BORDER_COLOR}`,
                            padding: "2px 8px",
                            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                            "&:hover": {
                                borderColor: EDITABLE_HOVER_BORDER,
                            },
                            "&:focus-within": {
                                borderColor: EDITABLE_FOCUS_BORDER,
                                borderStyle: "solid",
                                boxShadow: `0 0 0 2px rgba(25, 118, 210, 0.18)`,
                            },
                        }),
                    }}
                >
                    {editable && (
                        <Box
                            aria-hidden
                            sx={{
                                position: "absolute",
                                top: "-9px",
                                right: "6px",
                                fontSize: "0.7rem",
                                lineHeight: 1,
                                color: EDITABLE_ICON_COLOR,
                                backgroundColor: "#fff",
                                borderRadius: "50%",
                                px: 0.4,
                                py: 0.15,
                                border: `1px solid ${EDITABLE_BORDER_COLOR}`,
                                pointerEvents: "none",
                            }}
                        >
                            ✎
                        </Box>
                    )}
                    <TextField
                        name={name}
                        value={value ?? ""}
                        onChange={handleChange}
                        variant="standard"
                        fullWidth
                        placeholder={editable ? "Edit here…" : undefined}
                        InputProps={{
                            readOnly: !editable,
                            disableUnderline: true,
                        }}
                        sx={{
                            "& .MuiInputBase-input": {
                                fontSize: "0.95rem",
                                cursor: editable ? "text" : "default",
                                padding: "4px 0",
                            },
                            "& .MuiInputBase-input::placeholder": {
                                color: "#6b8cae",
                                fontStyle: "italic",
                                opacity: 1,
                            },
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

const FormRow = ({ children, isLast = false }) => (
    <Box
        sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            borderBottom: isLast ? "none" : borderSx,
            borderColor: "text.primary",
            "& > .form-cell + .form-cell": {
                borderTop: { xs: borderSx, md: "none" },
            },
        }}
    >
        {children}
    </Box>
);


const DEVANAGARI_DIGITS = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];
const toDevanagariNumeral = (num) =>
    String(num)
        .split("")
        .map((d) => DEVANAGARI_DIGITS[Number(d)] ?? d)
        .join("");

const DEFAULT_ROWS = [
    { sessionType: "सैद्धांतिक", subject: "", description: "" },
    { sessionType: "प्रात्यक्षिक", subject: "", description: "" },
    { sessionType: "प्रक्षेत्र", subject: "", description: "" },
];

const cellBorderSx = {
    border: borderSx,
    borderColor: "text.primary",
};

const SessionSubjectDetails = ({
    rows = DEFAULT_ROWS,
    title = "सत्र विषय तपशील",
    editable = false,
    minRowHeight = 90,
    onChange = null,
    onDescriptionChange = null,
    onSubjectChange = null,
    onCopyModuleName = null,
}) => {
    const handleSubjectChange = (rowIndex, newValue) => {
        if (onSubjectChange) onSubjectChange(rowIndex, newValue);
        else if (onChange) onChange(rowIndex, newValue);
    };

    const THEORY = "सैद्धांतिक";
    const PRACTICAL = "प्रात्यक्षिक";

    const getRowByType = (type) => rows.find((r) => r.sessionType === type);

    const theoryRow = getRowByType(THEORY);
    const practicalRow = getRowByType(PRACTICAL);

    const theoryHasModule = hasRealModule(theoryRow?.subject);
    const practicalHasModule = hasRealModule(practicalRow?.subject);

    const getCopySourceForRow = (sessionType) => {
        if (sessionType === THEORY) {
            if (!theoryHasModule && practicalHasModule) return PRACTICAL;
            return null;
        }
        if (sessionType === PRACTICAL) {
            if (!practicalHasModule && theoryHasModule) return THEORY;
            return null;
        }
        return null;
    };

    return (
        <TableContainer
            sx={{
                width: "100%",
                maxWidth: 1024,
                overflowX: "auto",
                fontFamily: '"Noto Sans Devanagari", "Mangal", Arial, sans-serif',
            }}
        >
            <Table
                sx={{
                    minWidth: { xs: 720, md: "100%" },
                    borderCollapse: "collapse",
                    border: borderSx,
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell
                            colSpan={3}
                            align="center"
                            sx={{
                                ...cellBorderSx,
                                fontWeight: 700,
                                fontSize: "1rem",
                                borderBottom: borderSx,
                            }}
                        >
                            {title}
                        </TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell
                            align="center"
                            sx={{ ...cellBorderSx, fontWeight: 700, width: 90 }}
                        >
                            सत्र क्र.
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{ ...cellBorderSx, fontWeight: 700, width: 160 }}
                        >
                            सत्र स्वरूप
                        </TableCell>
                        <TableCell align="center" sx={{ ...cellBorderSx, fontWeight: 700 }}>
                            विषय
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {rows.map((row, index) => {
                        const isFieldRow = row.sessionType === "प्रक्षेत्र";
                        const fieldIsEditable = editable || isFieldRow;
                        const copySource = getCopySourceForRow(row.sessionType);

                        return (
                            <TableRow key={index}>
                                <TableCell
                                    align="center"
                                    sx={{
                                        ...cellBorderSx,
                                        verticalAlign: "middle",
                                        height: minRowHeight,
                                    }}
                                >
                                    {toDevanagariNumeral(index + 1)}
                                </TableCell>

                                <TableCell
                                    align="center"
                                    sx={{
                                        ...cellBorderSx,
                                        verticalAlign: "middle",
                                    }}
                                >
                                    {row.sessionType}
                                </TableCell>

                                <TableCell
                                    sx={{
                                        ...cellBorderSx,
                                        verticalAlign: "top",
                                        p: fieldIsEditable ? 1 : 1.5,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 1,
                                        }}
                                    >
                                        {fieldIsEditable ? (
                                            <Box sx={{ position: "relative" }}>
                                                <Box
                                                    aria-hidden
                                                    sx={{
                                                        position: "absolute",
                                                        top: "-8px",
                                                        right: "10px",
                                                        fontSize: "0.7rem",
                                                        lineHeight: 1,
                                                        color: EDITABLE_ICON_COLOR,
                                                        backgroundColor: "#fff",
                                                        borderRadius: "50%",
                                                        px: 0.4,
                                                        py: 0.15,
                                                        border: `1px solid ${EDITABLE_BORDER_COLOR}`,
                                                        zIndex: 2,
                                                        pointerEvents: "none",
                                                    }}
                                                >
                                                    ✎
                                                </Box>
                                                <TextField
                                                    value={row.subject ?? ""}
                                                    onChange={(e) =>
                                                        handleSubjectChange(index, e.target.value)
                                                    }
                                                    variant="outlined"
                                                    fullWidth
                                                    multiline
                                                    minRows={3}
                                                    placeholder="येथे विषय प्रविष्ट करा… (click to edit)"
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            backgroundColor: EDITABLE_BG,
                                                            "& fieldset": {
                                                                borderColor: EDITABLE_BORDER_COLOR,
                                                                borderWidth: "1.5px",
                                                                borderStyle: "dashed",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: EDITABLE_HOVER_BORDER,
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: EDITABLE_FOCUS_BORDER,
                                                                borderWidth: "2px",
                                                                borderStyle: "solid",
                                                                boxShadow: `0 0 0 2px rgba(25, 118, 210, 0.15)`,
                                                            },
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            fontSize: "0.95rem",
                                                            whiteSpace: "pre-wrap",
                                                        },
                                                        "& .MuiInputBase-input::placeholder": {
                                                            color: "#6b8cae",
                                                            fontStyle: "italic",
                                                            opacity: 1,
                                                        },
                                                    }}
                                                />
                                            </Box>
                                        ) : (
                                            <Box
                                                sx={{
                                                    minHeight: minRowHeight - 24,
                                                    whiteSpace: "pre-wrap",
                                                    fontSize: "0.95rem",
                                                    px: 0.5,
                                                    py: 0.5,
                                                }}
                                            >
                                                {row.subject || ""}
                                            </Box>
                                        )}

                                        {copySource && (
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={() => onCopyModuleName?.(copySource)}
                                                sx={{
                                                    alignSelf: "flex-start",
                                                    textTransform: "none",
                                                    fontSize: "0.8rem",
                                                    fontWeight: 600,
                                                    borderColor: EDITABLE_BORDER_COLOR,
                                                    color: EDITABLE_ICON_COLOR,
                                                    backgroundColor: "#f5faff",
                                                    "&:hover": {
                                                        backgroundColor: "#e3f2fd",
                                                        borderColor: EDITABLE_HOVER_BORDER,
                                                    },
                                                }}
                                            >
                                                📋 Copy from{" "}
                                                {copySource === THEORY ? "सैद्धांतिक" : "प्रात्यक्षिक"}
                                            </Button>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

let DEFAULT_VALUES = {
    ekunPat: "",
    vidyarthi: "",
    vidyarthini: "",
    ekunUpasthit: "",
};

const StudentAttendanceCount = ({
    values = DEFAULT_VALUES,
    title = "उपस्थित विद्यार्थी संख्या",
    editable = true,
    autoCalculateTotal = true,
    onChange = null,
}) => {
    const emitChange = (fieldName, newValue) => {
        if (onChange) onChange(fieldName, newValue);
    };

    const handleFieldChange = (fieldName) => (e) => {
        const newValue = e.target.value;

        if (!/^\d*$/.test(newValue)) {
            return;
        }

        const ekunPat = fieldName === "ekunPat" ? newValue : values.ekunPat;
        const vidyarthi = fieldName === "vidyarthi" ? newValue : values.vidyarthi;
        const vidyarthini = fieldName === "vidyarthini" ? newValue : values.vidyarthini;
        const presentCount = (Number(vidyarthi) || 0) + (Number(vidyarthini) || 0);

        if (ekunPat !== "" && presentCount > Number(ekunPat)) {
            return;
        }

        emitChange(fieldName, newValue);

        if (
            autoCalculateTotal &&
            ["ekunPat", "vidyarthi", "vidyarthini"].includes(fieldName)
        ) {
            const numVidyarthi = Number(vidyarthi) || 0;
            const numVidyarthini = Number(vidyarthini) || 0;
            const totalPresent = numVidyarthi + numVidyarthini;
            const numEkunPat = Number(ekunPat) || 0;

            if (numEkunPat > 0 && (vidyarthi !== "" || vidyarthini !== "")) {
                const pct = (totalPresent / numEkunPat) * 100;
                emitChange("ekunUpasthit", pct.toFixed(2));
            } else {
                emitChange("ekunUpasthit", "");
            }
        }
    };

    const columns = [
        { key: "ekunPat", label: "एकूण पट" },
        { key: "vidyarthi", label: "उपस्थित विद्यार्थी" },
        { key: "vidyarthini", label: "उपस्थित विद्यार्थिनी" },
        { key: "ekunUpasthit", label: "एकूण उपस्थित %" },
    ];

    return (
        <TableContainer
            sx={{
                width: "100%",
                maxWidth: 1024,
                overflowX: "auto",
                fontFamily: '"Noto Sans Devanagari", "Mangal", Arial, sans-serif',
            }}
        >
            <Table
                sx={{
                    minWidth: { xs: 560, md: "100%" },
                    borderCollapse: "collapse",
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell
                            colSpan={columns.length}
                            align="center"
                            sx={{ ...cellBorderSx, fontWeight: 700, fontSize: "1rem" }}
                        >
                            {title}
                        </TableCell>
                    </TableRow>

                    <TableRow>
                        {columns.map((col) => (
                            <TableCell
                                key={col.key}
                                align="center"
                                sx={{ ...cellBorderSx, fontWeight: 700 }}
                            >
                                {col.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow>
                        {columns.map((col) => {
                            const isTotalField = col.key === "ekunUpasthit";
                            const fieldIsEditable =
                                editable && !(isTotalField && autoCalculateTotal);
                            const hasValue =
                                values[col.key] !== "" &&
                                values[col.key] !== undefined &&
                                values[col.key] !== null;

                            return (
                                <TableCell
                                    key={col.key}
                                    align="center"
                                    sx={{ ...cellBorderSx, height: 56, p: 1 }}
                                >
                                    {isTotalField ? (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                minHeight: 40,
                                                backgroundColor: hasValue ? EDITABLE_BG : "transparent",
                                                borderRadius: "4px",
                                                px: 1,
                                                py: 0.5,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: "1rem",
                                                    fontWeight: 700,
                                                    color: hasValue ? "#1d5a96" : "#999",
                                                }}
                                            >
                                                {hasValue ? `${values[col.key]}%` : "—"}
                                            </Typography>
                                        </Box>
                                    ) : fieldIsEditable ? (
                                        <Box sx={{ position: "relative" }}>
                                            <Box
                                                aria-hidden
                                                sx={{
                                                    position: "absolute",
                                                    top: "-8px",
                                                    right: "6px",
                                                    fontSize: "0.65rem",
                                                    lineHeight: 1,
                                                    color: EDITABLE_ICON_COLOR,
                                                    backgroundColor: "#fff",
                                                    borderRadius: "50%",
                                                    px: 0.35,
                                                    py: 0.1,
                                                    border: `1px solid ${EDITABLE_BORDER_COLOR}`,
                                                    zIndex: 2,
                                                    pointerEvents: "none",
                                                }}
                                            >
                                                ✎
                                            </Box>
                                            <TextField
                                                value={values[col.key] ?? ""}
                                                onChange={handleFieldChange(col.key)}
                                                variant="outlined"
                                                size="small"
                                                type="text"
                                                placeholder="संख्या"
                                                aria-label={`${col.label} संख्या`}
                                                inputProps={{
                                                    inputMode: "numeric",
                                                    min: 0,
                                                    style: { textAlign: "center" },
                                                }}
                                                fullWidth
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        backgroundColor: EDITABLE_BG,
                                                        "& fieldset": {
                                                            borderColor: EDITABLE_BORDER_COLOR,
                                                            borderWidth: "1.5px",
                                                            borderStyle: "dashed",
                                                        },
                                                        "&:hover fieldset": {
                                                            borderColor: EDITABLE_HOVER_BORDER,
                                                        },
                                                        "&.Mui-focused fieldset": {
                                                            borderColor: EDITABLE_FOCUS_BORDER,
                                                            borderWidth: "2px",
                                                            borderStyle: "solid",
                                                            boxShadow: `0 0 0 2px rgba(25, 118, 210, 0.15)`,
                                                        },
                                                    },
                                                    "& .MuiInputBase-input": {
                                                        fontSize: "0.95rem",
                                                        textAlign: "center",
                                                    },
                                                }}
                                            />
                                        </Box>
                                    ) : (
                                        <span style={{ fontSize: "0.95rem" }}>
                                            {values[col.key] ?? ""}
                                        </span>
                                    )}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        GenerRateReport: (data) => dispatch(Action.GenerRateReport(data)),
        getCategories: (data) => dispatch(Action.getCategories(data)),
    }
}

export default connect(null, mapDispatchToProps)(FormFill)